/**
 * Media Module Configuration
 *
 * Standalone media management module with embeddable components.
 * Media is entity-agnostic — any module can embed the MediaPanel
 * by passing entityType + entityId.
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const mediaModule: AppModule = {
    id: 'media',

    navigation: {
        label: 'Media Library',
        icon: 'media',
        path: '/media',
        order: 40,
        moduleKey: 'media_library',


        pages: [
            {
                label: 'All Media',
                path: '/media',
            },
        ],
    },

    routes,
}

export default mediaModule
